import Typography from '@components/Typography';
import Button from '@components/Button/next';
import { FlexibleDiv } from '@components/formStyles';
import { useDevice } from '@contexts/device';
import { CloseIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  ButtonsWrapper,
  CloseIconWrapper,
  ModalWrapper,
  Wrapper,
} from './style';

type Props = {
  onClose: () => void;
};

const CurrentCardTourDifferentDatesModal = ({ onClose }: Props) => {
  const { isDesktop } = useDevice();
  return (
    <ModalWrapper>
      <Wrapper>
        <CloseIconWrapper>
          <CustomIcon
            fontSize={24}
            paletteColor='brownishGrey'
            icon={CloseIcon}
            onClick={onClose}
          />
        </CloseIconWrapper>

        <FlexibleDiv bottom={20}>
          <Typography color='D400' variant='caption1' weight='Regular' as='p'>
            Sadece bir adet tur satın alınabilir devam etmek için seçiminizi
            güncelleyiniz.
          </Typography>
        </FlexibleDiv>

        <ButtonsWrapper>
          <Button block variant='Primary' onClick={onClose}>
            <Typography
              color='white'
              variant={isDesktop ? 'caption1' : 'caption2'}
              weight={isDesktop ? 'SemiBold' : 'Bold'}
            >
              Tamam
            </Typography>
          </Button>
        </ButtonsWrapper>
      </Wrapper>
    </ModalWrapper>
  );
};

export default CurrentCardTourDifferentDatesModal;
